enum SignatureDialogReturnType {
  PNG,
  JPEG,
  SVG,
  BLOB,
  CANVAS,
}

export default SignatureDialogReturnType;
